import { useEffect, useRef } from "react";
import useGlobalContext from "./useGlobalContext.js";
import useRouteName from "./useRouteName.js";
import useGTMRouteChangeEvent from "./useGTMRouteChangeEvent.js";
const useRouteChangeTracking = () => {
    const { marketingTrackingVariables } = useGlobalContext();
    const routeName = useRouteName();
    const GTMRouteChangeEvent = useGTMRouteChangeEvent();
    const gtmRouteChangeTrackingRef = useRef({
        GTMRouteChangeEvent
    });
    useEffect(() => {
        const { GTMRouteChangeEvent } = gtmRouteChangeTrackingRef.current;
        GTMRouteChangeEvent();
    }, [routeName, marketingTrackingVariables]);
};
export default useRouteChangeTracking;
